import "babel-polyfill"
import React from "react"
import { Provider } from "react-redux"
import { Switch, Route } from "react-router-dom"
import { TransitionGroup, CSSTransition } from "react-transition-group"
import { ConnectedRouter } from "connected-react-router"
import { get } from "lodash"
import { PersistGate } from "redux-persist/integration/react"

// Pages

import CityPage from "./City/CityPage"
import LoadingPage from "./components/LoadingPage"
import ResumePage from "./components/ResumePage"
import SearchPage from "./search/Search"

import TransportationAddresses from "./transportation/TransportationPage"

import Futbol from "./futbol"
import FutbolConfirmation from "./futbol/ConfirmationPage"
import AskRoomNumber from "./hotels/AskRoomNumber"
import HotelLaundry from "./hotels/Laundry.jsx"
import HotelLaundryInfo from "./hotels/LaundryInfo.jsx"
import HotelMenuIndex from "./hotels/HotelMenuIndex"
import HotelMenuSection from "./hotels/HotelMenuSection.jsx"
import HotelRestaurants from "./hotels/HotelRestaurants"
import Room from "./hotels/Room"
import Tepa from "./hotels/Tepa"
import TepaRooms from "./hotels/TepaRooms"

import TermsOfServicePage from "./pages/TermsOfService"
import WelcomePage from "./pages/WelcomePage"
import Menu from "./products/Menu"
import MenuContent from "./products/MenuContent"
import ProductDescription from "./products/ProductDescription"
import FormPage from "./reservation/FormPage"
import ReservationPage from "./reservation/ReservationPage"
import ReviewPage from "./reservation/ReviewPage"
import ConfirmationPage from "./reservation/ConfirmationPage"

import Ticketselection from "./reservation/TicketSelection"

// Styles
import "./global.less"
import "./hotels/tepaPage.less"

// Store 
import configureStore from "./store/configureStore"

const { store, persistor, history } = configureStore()

/**
 *
 */

const routes = [
  { alsoWithCity: true, path: "citypage", component: CityPage, },
  { alsoWithCity: true, path: "transportation", component: TransportationAddresses, },
  { alsoWithCity: true, path: "selection", component: CityPage, },
  
  { path: "futbol", component: Futbol, },
  { path: "futbol/confirmation", component: FutbolConfirmation, },
  { path: "product/:id", component: ProductDescription, },
  { path: "reservation/selections/:id", component: ReservationPage, },
  { path: "reservation/ticketselection/:id", component: Ticketselection, },
  { alsoWithCity: true, path: "reservation/formpage/:id", component: FormPage, },
  { alsoWithCity: true,  path: "reservation/reviewpage/:id", component: ReviewPage, },
  { path: "confirmation", component: ConfirmationPage, },
  { path: "resume/:id", component: ResumePage, },
  { path: "search/", component: SearchPage },
  { path: "tos", component: TermsOfServicePage, },
  { path: "transportation", component: TransportationAddresses, },
  { path: "menu/:product_id", component: Menu, },
  { path: "menuContent/:product_id/:menu_id", component: MenuContent, },
  
  { path: "tepa/ask", component: AskRoomNumber, },
  { path: "tepa/rooms", component: TepaRooms, },
  { path: "room/:key", component: Room, },
  { path: "tepa/restaurant", component: HotelRestaurants, },
  { path: "tepa/menu/:section", component: HotelMenuSection, },
  { path: "tepa/menu", component: HotelMenuIndex, },
  { path: "tepa/laundryInfo", component: HotelLaundryInfo, },
  { path: "tepa/laundry", component: HotelLaundry, },
  { path: "tepa", component: Tepa, },  
]

function deleteSubRoutes(pathname) {
  if (pathname.indexOf("selections") >= 0) {
    return pathname.split("/").slice(0, 5).join("/") 
  }
  return pathname
}

class App extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      showDialog: false,
    }
  }

  render() {
    return (
      <div>
        <Provider store={store}>
          <PersistGate loading={<LoadingPage />} persistor={persistor} delaySeconds={300}>
            <ConnectedRouter history={history}>
              <Route
                render={({ location }) => (
                  <div>
                    <TransitionGroup className={get(store.getState(), "router.action", "PUSH")}>
                      <CSSTransition
                        key={window.matchMedia("(min-width: 735px)").matches ? "none" : deleteSubRoutes(location.pathname)}
                        classNames="page"
                        unmountOnExit
                        timeout={300}
                      >
                        <Switch location={location}>
                          <Route  exact path="/" component={WelcomePage} />
                          <Route  exact path="/catalogo" component={WelcomePage} />
                  
                          {
                            routes.map(({ path, component }) => (
                              <Route
                                key={`${path}a`}
                                path={`/catalogo/${path}`}
                                component={component}
                              />
                            ))
                          }
                          
                          {
                            routes
                              .filter(({ alsoWithCity }) => alsoWithCity)
                              .map(({ path, component }) => (
                                <Route
                                  key={`${path}b`}
                                  path={`/catalogo/:city/${path}`}
                                  component={component}
                                />
                              ))
                          }

                          {/* has to be last, or /catalogo/tos will be interpreted as a city named tos */}
                          <Route  exact path="/catalogo/:city" component={CityPage} />
                        </Switch>
                      </CSSTransition>
                    </TransitionGroup>
                  </div>

                )}
              >
              </Route>
            </ConnectedRouter>
          </PersistGate>
        </Provider>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/app/catalogo/index.js